import { Button } from 'antd';
import classnames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import { SComment } from '@root/modules/Sellers/Inquiry/interfaces';
import SkeletonButton from 'antd/lib/skeleton/Button';

interface Props {
  title: string;
  primary: string;
  statusButton?: boolean;
  statusToDisable?: string;
  productId?: number;
  listCmt?: any;
  mylastComment?: string;
}

function Approve({
  title,
  primary,
  statusToDisable,
  productId,
  listCmt,
  mylastComment
}: Props) {
  const [listQuotationComment, setListQuotationComment] = useState<SComment[]>(
    []
  );
  const [button, setButton] = useState(Boolean);

  const _getDataSell = useCallback(async () => {
    if (productId) {
      const comment = await InquiryServices.getQuoteComment(productId);
      setListQuotationComment(comment.data);
    }
  }, [productId]);

  useEffect(() => {
    _getDataSell();
  }, [_getDataSell, statusToDisable]);

  useEffect(() => {
    if (statusToDisable === 'WarehouseApproved') {
      setButton(false);
    } else if (
      (statusToDisable === 'New' || statusToDisable === 'Rejected') &&
      listQuotationComment.length >= 2
    ) {
      setButton(false);
    } else {
      setButton(true);
    }
  }, [productId]);

  return (
    <>
      {productId ? (
        <>
          <div className="btnApprove">
            <Button
              className={classnames('btnPrimary', `primary-${primary}`)}
              type="primary"
              disabled={
                statusToDisable === 'SellerApproved'
                  ? true
                  : statusToDisable === 'WarehouseApproved'
                  ? false
                  : statusToDisable === 'New' &&
                    listQuotationComment.length >= 2
                  ? false
                  : statusToDisable === 'Rejected' &&
                    listQuotationComment.length >= 2
                  ? false
                  : true
              }
            >
              {title}
            </Button>
          </div>
        </>
      ) : (
        <>
          {statusToDisable === 'Rejected' ||
          statusToDisable === 'SellerApproved' ||
          statusToDisable === 'WarehouseApproved' ||
          (title === 'Approve' &&
            statusToDisable === 'New' &&
            listCmt?.length < 1 &&
            mylastComment !== 'Seller') ? (
            <>
              <div className="btnApprove">
                <Button
                  className={classnames('btnPrimary', `primary-${primary}`)}
                  type="primary"
                  disabled
                >
                  {title}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="btnApprove">
                <Button
                  className={classnames('btnPrimary', `primary-${primary}`)}
                  type="primary"
                >
                  {title}
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}

export default Approve;
